export function Dot() {
  return <div className="inline-block w-1 h-1 bg-gray-500 rounded-full" />;
}
